import { getOpenFundRequests } from '@/api/MeitavDashApi';

export default {
  namespaced: true,
  state: {
    requestStatus: undefined,
    fundNumber: undefined,

    stateInitiated: false,
  },
  getters: {
    hasStatus: state => state.requestStatus !== undefined,
    isCreated: state => state.requestStatus === 'created',
    isApproved: state => state.requestStatus === 'approved',
    isSubmitted: state => state.requestStatus === 'submitted',
    isSubmittedWithErrors: state => state.requestStatus === 'submitted_with_errors',
  },
  mutations: {
    setRequestStatus(state, status) {
      state.requestStatus = status;
    },
    setFundNumber(state, fundNumber) {
      state.fundNumber = fundNumber;
    },
    setStateInitiated(state) {
      state.stateInitiated = true;
    },
  },
  actions: {
    async initFundRequests({ state, dispatch }) {
      if (state.stateInitiated) {
        return;
      }
      await dispatch('refreshFundStatus');
    },
    async refreshFundStatus({ commit }) {
      const { requests } = await getOpenFundRequests();
      if (!requests) {
        return;
      }
      // We currently support only one request per customer
      const [fundRequest] = requests;
      if (fundRequest) {
        commit('setRequestStatus', fundRequest.status);
        commit('setFundNumber', fundRequest.fundNumber);
      }
      commit('setStateInitiated');
    },
  },
};
